import React, { type ReactElement, type ReactNode } from "react";
import { Sparkles, type LucideIcon } from "lucide-react";

// The AI marker (NO-791): what says a piece of text came from AI. Classic, it
// is a pink icon beside the label, as today. Under the always theme it is the
// prototype's pink dot with the label in mono caps, on the short label only
// ("Draft generated 2:30 PM"), never the sentence around it. Neither part
// takes a className, so brand: utilities carry the theme without beating a
// caller's override. A leaf module (`import React`) so `tsx --test` renders it.

/** The marker's glyph: the classic icon, or the theme's pink dot. */
export function AiMarkerGlyph({
  icon: Icon = Sparkles,
}: {
  icon?: LucideIcon;
}): ReactElement {
  return (
    <>
      <Icon
        aria-hidden="true"
        className="mt-0.5 size-3.5 shrink-0 text-ai brand:hidden"
      />
      <span
        aria-hidden="true"
        data-ai-marker-dot=""
        className="mt-[5px] hidden size-[7px] shrink-0 rounded-full bg-ai brand:inline-block"
      />
    </>
  );
}

/** The short label the marker names, such as "Draft generated 2:30 PM". */
export function AiMarkerLabel({ children }: { children: ReactNode }): ReactElement {
  return (
    <span className="font-medium text-foreground brand:font-mono brand:text-[11px] brand:uppercase brand:tracking-[0.1em] brand:text-(color:--ai-marker-ink)">
      {children}
    </span>
  );
}
